export const environment = {
  production: true,
  API: 'https://od-nl.lanars-dev.com/api/admin',
  env: 'develop'
};
